import { IAppState } from 'shared/common/state';
import { EHideOfferState } from 'shared/serp/state/hide_offer';

/**
 * Селектор для получения состояния скрытия оффера
 */
export const selectHideOfferState = (state: IAppState): EHideOfferState => state.hideOffer.hideOfferState;

/**
 * Селектор для проверки открыт ли топ попап
 */
export const selectIsTopPopupOpened = (state: IAppState): boolean => state.hideOffer.isTopPopupOpened;

/**
 * Селектор для получения сообщения об ошибке скрытия оффера
 */
export const selectHideOfferErrorMessage = (state: IAppState): string => state.hideOffer.hideOfferErrorMessage;

/**
 * Селектор для проверки находится ли скрытие оффера в состоянии ошибки
 */
export const selectIsHideOfferError = (state: IAppState): boolean =>
  state.hideOffer.hideOfferState === EHideOfferState.ERROR;
